export default __webpack_public_path__ + "static/media/ic_clock.a6b4ac1c.svg";